import React, { useState } from "react";
import styles from "./style.module.css";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import BackButton from "../back-button";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../context/themeContext";
import { unsubscribe } from "../../../helpers/emails";
import useProtectedAuth from "../../../hooks/useProtectedAuth";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../../store/slices/userSlice";
import axios from "axios";
import { node_server } from "../../../constants";

function EmailPreferences() {
  useProtectedAuth();
  const { theme } = useTheme();
  const [emailPreference, setEmailPreference] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.value);

  const handleSave = async () => {
    const response = await axios.post(
      `${node_server}/api/user/update`,
      {
        emailPreference: emailPreference,
      },
      {
        withCredentials: true,
      },
    );
    const { data, error } = response;

    if (error) console.log(error);
    if (data) {
      if (emailPreference === "No matches & updates (complete opt-out)") {
        await unsubscribe(user?.id);
      }

      dispatch(setUser(data));
      navigate("/settings");
    }
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <Box
      className={styles.subStatus}
      sx={{
        bgcolor: theme.palette.lightgrey.lightgrey600,
      }}
    >
      <BackButton />
      <Box className={styles.container}>
        <Box className={styles.details}>
          <Box className={styles.content}>
            <Typography
              variant="body1"
              component="h3"
              sx={{
                color: theme.palette.darkgrey.darkgrey700,
                fontSize: "24px",
                fontWeight: "500",
              }}
            >
              Email Preferences
            </Typography>
            <FormControl
              sx={{
                color: theme.palette.darkgrey.darkgrey500,
                "& .MuiFormControlLabel-label": {
                  fontSize: "14px",
                },
              }}
            >
              <RadioGroup
                name="emailPreference"
                defaultValue={user.email_preference}
                onChange={(e) => setEmailPreference(e.target.value)}
              >
                <FormControlLabel
                  value="Daily matches & updates"
                  control={<Radio />}
                  label="Daily matches & updates"
                />
                <FormControlLabel
                  value="Weekly matches & updates"
                  control={<Radio />}
                  label="Weekly matches & updates"
                />
                <FormControlLabel
                  value="Monthly matches & updates"
                  control={<Radio />}
                  label="Monthly matches & updates"
                />
                <FormControlLabel
                  value="No matches & updates (complete opt-out)"
                  control={<Radio />}
                  label="No matches & updates (complete opt-out)"
                />
              </RadioGroup>
            </FormControl>
          </Box>
          <Button variant="contained" fullWidth onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
export default EmailPreferences;
